import NewMemberList from 'routes/NewMemberAnalytics/NewMemberList/NewMemberList';

export default NewMemberList;
